/*
 *
 * File JS per la Homepage
 *
 */

import './general.scss';

// IMPORT COMPONENTI
//--------------------------------------------------------------------//
import breadcrumbs from 'components/breadcrumbs/breadcrumbs';
import cmsContent from 'components/cms-content/cms-content';
import titleBox from 'components/title-box/title-box';
import modal from 'imComponents/modal/modal';
import accordion from 'imComponents/accordion/accordion';

import heroSlider from 'imComponents/hero-slider/hero-slider';
import heroImage from 'imComponents/hero-image/hero-image';
import contactForm from 'components/contact-form/contact-form';
import textIframe from 'components/text-iframe/text-iframe';
import initSliders from 'components/sliders/sliders';
import archiveList from 'components/archive-list/archive-list';

import cardNews from 'components/cards/card-news';

import textOnBg from 'imComponents/text-on-bg/text-on-bg';
import customQuote from 'components/custom-quote/custom-quote';
import textImgVar from 'imComponents/text-img-var/text-img-var';
import colTitleText from 'components/col-title-text/col-title-text';
import boxImage from 'components/box-image/box-image';
import cardsTextBg from 'components/cards-text-bg/cards-text-bg';
import blockTwoImages from 'components/block-two-images/block-two-images';
import overlappingImages from 'components/overlapping-images/overlapping-images';
import menu from 'components/menu/menu';
import menuAccordion from 'components/menu-accordion/menu-accordion';

//
//--------------------------------------------------------------------//
// INIT COMPONENTI
//--------------------------------------------------------------------//
function initAllComponents() {
    if (!document.querySelector('body.wp-admin')) {
        heroSlider();
    }
    modal();
    initSliders();
    accordion();
}

if (document.querySelector('body.wp-admin')) {
    (function ($) {
        var initBlock = function ($block) {
            initAllComponents();
        };
        if (window.acf) {
            window.acf.addAction('render_block_preview', initBlock);
        }
    })(jQuery);
}

initAllComponents();
//--------------------------------------------------------------------//
